import { predicates } from '../predicates/index';
import { selectors } from '../selectors/index';
import { TRAFFIC_SOURCES } from '../constants';

export const paid = {
  rule: predicates.and(
    predicates.searchParamsIncludeKey('utm_source'),
    predicates.or(
      predicates.searchParamEqualsValue('utm_medium', 'fbads'),
      predicates.searchParamEqualsValue('utm_medium', 'cpc'),
      predicates.searchParamEqualsValue('utm_medium', 'fbads_dyn'),
      predicates.searchParamEqualsValue('utm_source', 'googlecpc'),
      predicates.searchParamEqualsValue('utm_source', 'cpc'),
    ),
  ),
  extractor: (traffic) => {
    const trafficSource = TRAFFIC_SOURCES.PAID;
    const trafficId = selectors.searchParamValue(traffic, 'utm_source');

    return {
      trafficSource,
      trafficId,
    };
  },
};
